const updateTime = (party) => {
  const value = party.lastUpdateDate
    ? new Date(party.lastUpdateDate).getTime()
    : NaN;
  return Number.isNaN(value) ? -Infinity : value;
};

export function dashboardParties(
  clients = [],
  users = [],
  works = [],
  isCompany = false
) {
  const counts = new Map();
  const latestWorkIndex = new Map();
  for (const [index, work] of works.entries()) {
    if (isCompany && work.isOrdered !== true) continue;
    const id = isCompany ? work.user?.userId : work.client?.clientId;
    if (id != null) {
      const key = String(id);
      counts.set(key, (counts.get(key) || 0) + 1);
      if (!latestWorkIndex.has(key)) latestWorkIndex.set(key, index);
    }
  }
  const parties = isCompany
    ? users
        .filter((user) => !user.role || user.role === "user")
        .map((user) => ({
          ...user,
          clientId: user.userId,
          name: user.name || user.username
        }))
    : clients;
  return parties
    .map((party) => ({
      ...party,
      carpenterName: party.user?.name || party.user?.username || "",
      workCount: counts.get(String(party.clientId)) || 0
    }))
    .sort((a, b) => {
      const aWorkIndex = latestWorkIndex.get(String(a.clientId)) ?? Infinity;
      const bWorkIndex = latestWorkIndex.get(String(b.clientId)) ?? Infinity;
      if (aWorkIndex !== bWorkIndex) return aWorkIndex - bWorkIndex;
      const aTime = updateTime(a),
        bTime = updateTime(b);
      return aTime === bTime
        ? Number(b.clientId) - Number(a.clientId)
        : aTime > bTime
          ? -1
          : 1;
    });
}
